<div class="modal opened">
      <div class="modal-signature-main">
        <div class="modal-header">
          <h2>{{title}}</h2>
        </div>
        <p class="txt" [innerHTML]="text">{{text}}</p>
        <div class="box_item">
          <form>
            <label class="box-label" [hidden]="label == ''">{{label}}</label>
            <input [placeholder]="placeholder" autocomplete="off" type="password" [(ngModel)]="input" [ngModelOptions]="{standalone: true}">
          </form>
        </div>
        <fieldset [ngClass]="{'two-buttons': secondButtonText != ''}">
          <core-helpers-forms-button
            [type]="'grey'"
            [text]="secondButtonText"
            (submit)="onSecondAction()"
            [hidden]="secondButtonText == ''"
          ></core-helpers-forms-button>
          <core-helpers-forms-button-white
            [disabled]="!isInputReady() || disabled"
            [text]="buttonText" 
            (submit)="onAction()"
          ></core-helpers-forms-button-white>
        </fieldset>
        <div class="sso-form">
            <!-- // TODO: review scss when  single sign on is used again
            <strong>or</strong>
            <header>Sign with</header>
            <core-helpers-sso-providers (ssoLogin)="onSso($event)"></core-helpers-sso-providers> -->
        </div>
    </div>
</div>
